import { render, staticRenderFns } from "./ButtonsTest.vue?vue&type=template&id=2f7c4700&scoped=true&"
import script from "./ButtonsTest.vue?vue&type=script&lang=js&"
export * from "./ButtonsTest.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsTest.vue?vue&type=style&index=0&id=2f7c4700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c4700",
  null
  
)

export default component.exports